import { gql } from 'apollo-boost';

export const UPLOAD_VIDEO_FROM_URL = gql`
    mutation($data: UploadVideoFromUrlInput!) {
        uploadVideoFromUrl(data: $data) {
            url
            name
            displayName
            type
            format
            size
            mime
        }
    }
`;
